import { render, staticRenderFns } from "./BookingTravellerExtra.vue?vue&type=template&id=35933310&scoped=true&"
import script from "./BookingTravellerExtra.vue?vue&type=script&lang=js&"
export * from "./BookingTravellerExtra.vue?vue&type=script&lang=js&"
import style0 from "./BookingTravellerExtra.vue?vue&type=style&index=0&id=35933310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35933310",
  null
  
)

export default component.exports